module.exports = __webpack_public_path__ + "img/ico-gathering02.dd98e946.svg";